import { type TCart, useTheme } from "@up/data";

type Props = {
  student?: TCart["student"];
};

const bullet = "md:before:content-['•'] before:text-gray-400 md:before:mr-3";

export default function StudentInformationDisplay({ student }: Props) {
  const theme = useTheme();

  if (student && (student.firstName || student.lastName || student.email)) {
    return (
      <div className="bg-gray-100 p-4 rounded">
        <p className="flex flex-col md:flex-row gap-1 md:gap-3 md:items-center mb-3">
          <strong>
            {student.firstName} {student.lastName}
          </strong>
          {student.email && <strong className={bullet}>{student.email}</strong>}
        </p>

        {student.age || student.address ? (
          <p className="flex gap-3 items-center leading-none text-sm text-gray-500">
            {!theme.noGuardian && student.age ? (
              <span>Age: {student.age}</span>
            ) : null}
            {student.address?.country ? (
              <span className={bullet}>Country: {student.address.country}</span>
            ) : null}
            {student.address?.zipCode ? (
              <span className={bullet}>
                {student.address.country === "United States"
                  ? "Zip Code"
                  : "Postal Code"}
                : {student.address.zipCode}
              </span>
            ) : null}
          </p>
        ) : null}
      </div>
    );
  }

  return null;
}
